import { createContext } from 'preact';
import { useContext } from 'preact/hooks';
import type { ArcticApiClient } from './client';

export const ApiClientContext = createContext<ArcticApiClient | null>(null);

export function useApiClient(): ArcticApiClient {
  const client = useContext(ApiClientContext);
  if (!client) {
    throw new Error(
      'useApiClient must be used within an ApiClientContext.Provider',
    );
  }
  return client;
}
